import { Pipe, PipeTransform } from '@angular/core';
import { FormNamingUtil } from '../utils/form-naming.util';

@Pipe({
  name: 'questionName',
  pure: true
})
export class QuestionNamePipe implements PipeTransform {
  transform(questionNumber: number): string {
    return FormNamingUtil.getQuestionName(questionNumber);
  }
}
